<template>
  <vs-popup class="vs-con-loading__container user-edit-popup"
            id="popup"
            title="UPDATE STAFF GROUP"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickGroupUpdate)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
              <small class="label">Group Name</small>
              <vs-input v-model="selectedGroup.name"  required name="name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <small class="label">Group Description</small>
              <vs-textarea v-model="selectedGroup.description" height="100px"/>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ejs-treeview id='treeviewupdate' 
                :fields="fields" 
                :showCheckBox='true' 
                :nodeChecked='nodeChecked' 
                :allowEditing='true' 
                :nodeEditing='editing' 
                @nodeEdited="nodeEdited" 
                ></ejs-treeview>
                <!-- :nodeTemplate="itemTemplate" -->
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import vSelect from 'vue-select'
  import Vue from 'vue';
  import {TreeViewPlugin} from "@syncfusion/ej2-vue-navigations";
  Vue.use(TreeViewPlugin);
  const PermissionRepository = RepositoryFactory.get('permissions')
  const RolesRepository = RepositoryFactory.get('roles')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import PermissionItem from './PermissionItem.vue'

  function initialState() {
    return {
      open: false,
      allPermissions: [],
      dataSource: [],
      selectedGroup: {},
      fields: {},
      selectedPermissionNode: [],
      realTimeCheckedNodeCreate: [],
      id: null,
      itemTemplate () {
          return { template: PermissionItem }
        },
    }
  }
  export default {
  name: 'UpdateStaffGroupPopUp',
  data () {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods:{
    async openPopup (id) {
      await Object.assign(this.$data, initialState())
      this.open = true;
      this.$vs.loading()
      await this.$forceUpdate()
      await this.initialize(id)
      this.id = id
      this.$vs.loading.close()
    },
    nodeChecked: function(args) {
      const treeObj = document.getElementById('treeviewupdate').ej2_instances[0];
      this.realTimeCheckedNodeCreate = treeObj.checkedNodes
    },
    async onClickGroupUpdate() {
      const vue = this
      this.$vs.loading()
      try {
        const allPermissionsIds = await this.allPermissions.map((ps) => {
          return ps.id
        });

        if (this.realTimeCheckedNodeCreate.length === 0){
          this.selectedGroup.permissions = this.selectedPermissionNode;
        }else {
          this.selectedGroup.permissions = await this.realTimeCheckedNodeCreate.filter((real) => {
            if (allPermissionsIds.includes(+(real))) {
              return +(real)
            }
          });
        }

        // const check_if_selected_rm_supplier_permissions = this.selectedGroup.permissions
        //   .some(r=> ["65","66", "67", "68", "69", "70", "71", "72", "73"].indexOf(r) >= 0)
        // if(check_if_selected_rm_supplier_permissions) {
        //   this.selectedGroup.permissions.push("62", "63", "64");
        // }
        this.selectedGroup.permissions = this.selectedGroup.permissions.map((x) => {return Number(x)})

        await RolesRepository.updateRole(this.selectedGroup.id, this.selectedGroup)
        this.showSuccessMessage('Selected staff group update successfully!')
        this.open = false;
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
      await vue.$parent.refreshData()
    },
    async initialize(id) {
      try {
        const role_data = await RolesRepository.getRole(id)
        this.selectedGroup = role_data.data.data
        this.selectedPermissionNode = []
        this.selectedPermissionNode = this.selectedGroup.permissions.map((ps) => ps.id);

        // data source
        const {data} = await PermissionRepository.get()
        this.allPermissions = data.permissions.map((x) => {
          // x.name = x.name.replaceAll('-', ' ')
          x.name = x.label
          return x;
        });
        this.dataSource = data.permission_groups.concat(data.permissions)
        this.dataSource = this.dataSource.map((ds) => {
          ds.isChecked = this.selectedPermissionNode.includes(ds.id);
          ds.expanded = !ds.parent_id;
          return ds;
        });
        this.fields = { dataSource: this.dataSource, id: 'id', parentID: 'parent_id', text: 'name', hasChildren: 'has_child' }
      } catch (error) {
        this.showErrorMessage('Something went wrong!')
      }
    },
    async onClickReset() {
      this.$vs.loading();
      await this.initialize(this.id)
      this.$vs.loading.close();
    },
    editing: function (args) {
            if (args.nodeData.hasChildren) {
                args.cancel = true;
            }
    },
    async nodeEdited(data) {
      if(data.name === "nodeEdited" && data.oldText !== data.newText) {
        await PermissionRepository.updatePermissionName(data.nodeData.id, { label:  data.newText})
      }
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  }
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
